export default __webpack_public_path__ + "static/projects-a150b6990cb4e0faac3cbd928e23c453.webp";